import TextField from '@material-ui/core/TextField'

const SearchInput = props => <TextField fullWidth placeholder="Search icons..." onChange={props.onSearch} />

export default SearchInput